import Layout from "../components/Layout";
import HomeMain from "../components/HomeMain";

const Home = () => {
    return (
    <Layout>
        <HomeMain/>
    </Layout>
    );
}

export default Home;
